import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = ({ 
  showNavigation = true, 
  showAuthButtons = true, 
  showLogout = false, 
  onLogout = null,
  userEmail = null,
  backgroundColor = 'white',
  showSubtitle = false,
  subtitle = ''
}) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header style={{
      padding: '20px 0',
      borderBottom: '1px solid #eee',
      backgroundColor: backgroundColor
    }}>
      <div className="container">
        <nav style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          position: 'relative'
        }}>
          {/* Logo */}
          <Link to="/" style={{ textDecoration: 'none' }}>
            <h1 style={{
              fontSize: '32px',
              fontWeight: 'bold',
              color: '#333'
            }}>
              Floors.
            </h1>
          </Link>
          
          {/* Desktop Navigation */}
          {showNavigation && (
            <div style={{
              display: 'flex',
              gap: '20px',
              alignItems: 'center'
            }} className="desktop-nav">
              <a href="#" style={{ color: '#666', textDecoration: 'none' }}>Our Properties</a>
              <a href="#" style={{ color: '#666', textDecoration: 'none' }}>How to sit successfully</a>
              <a href="#" style={{ color: '#666', textDecoration: 'none' }}>About us</a>
              <Link to="/settings" style={{ color: '#666', textDecoration: 'none' }}>⚙️ Settings</Link>
            </div>
          )}
          
          {/* Desktop Auth Buttons */}
          <div style={{ 
            display: 'flex', 
            gap: '20px', 
            alignItems: 'center'
          }} className="desktop-auth">
            {showAuthButtons && (
              <>
                <Link to="/login" className="btn btn-secondary">Login</Link>
                <Link to="/register" className="btn btn-primary">Register</Link>
              </>
            )}
            
            {showLogout && (
              <>
                {userEmail && (
                  <span style={{ color: '#666' }}>Welcome, {userEmail}</span>
                )}
                <button onClick={onLogout} className="btn btn-secondary">Logout</button>
              </>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMobileMenu}
            style={{
              display: 'none',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '8px'
            }}
            className="mobile-menu-btn"
          >
            <div style={{
              width: '25px',
              height: '3px',
              backgroundColor: '#333',
              margin: '5px 0',
              transition: '0.3s',
              transform: isMobileMenuOpen ? 'rotate(-45deg) translate(-5px, 6px)' : 'none'
            }}></div>
            <div style={{
              width: '25px',
              height: '3px',
              backgroundColor: '#333',
              margin: '5px 0',
              transition: '0.3s',
              opacity: isMobileMenuOpen ? 0 : 1
            }}></div>
            <div style={{
              width: '25px',
              height: '3px',
              backgroundColor: '#333',
              margin: '5px 0',
              transition: '0.3s',
              transform: isMobileMenuOpen ? 'rotate(45deg) translate(-5px, -6px)' : 'none'
            }}></div>
          </button>
        </nav>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div style={{
            position: 'absolute',
            top: '100%',
            left: '0',
            right: '0',
            backgroundColor: 'white',
            borderBottom: '1px solid #eee',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            zIndex: 1000,
            padding: '20px 0',
            marginTop: '0'
          }} className="mobile-menu">
            {showNavigation && (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
                marginBottom: '20px',
                padding: '0 20px'
              }}>
                <a href="#" style={{ color: '#666', textDecoration: 'none', fontSize: '16px' }}>Our Properties</a>
                <a href="#" style={{ color: '#666', textDecoration: 'none', fontSize: '16px' }}>How to sit successfully</a>
                <a href="#" style={{ color: '#666', textDecoration: 'none', fontSize: '16px' }}>About us</a>
                <Link to="/settings" style={{ color: '#666', textDecoration: 'none', fontSize: '16px' }}>⚙️ Settings</Link>
              </div>
            )}
            
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              gap: '15px',
              padding: '0 20px'
            }}>
              {showAuthButtons && (
                <>
                  <Link to="/login" className="btn btn-secondary" style={{ textAlign: 'center' }}>Login</Link>
                  <Link to="/register" className="btn btn-primary" style={{ textAlign: 'center' }}>Register</Link>
                </>
              )}
              
              {showLogout && (
                <>
                  {userEmail && (
                    <span style={{ color: '#666', textAlign: 'center', marginBottom: '10px' }}>Welcome, {userEmail}</span>
                  )}
                  <button onClick={onLogout} className="btn btn-secondary" style={{ textAlign: 'center' }}>Logout</button>
                </>
              )}
            </div>
          </div>
        )}
      </div>
      
      {showSubtitle && subtitle && (
        <div className="container">
          <h2 style={{
            marginBottom: '20px',
            color: '#333',
            textAlign: 'center',
            marginTop: '40px'
          }}>
            {subtitle}
          </h2>
        </div>
      )}
    </header>
  );
};

export default Header;
